import type { ElementType } from 'react'
import { BanknotesIcon, CreditCardIcon, CubeIcon } from '@heroicons/react/20/solid'

export interface Service {
  id: string
  number: string
  name: string
  shortDesc: string
  description: string[]
  icon: ElementType
  href: string
}

export const services: Service[] = [
  {
    id: 'acquiring',
    number: '01',
    name: 'Acquiring',
    shortDesc:
      'By ensuring compliance, interoperability, and faster time-to-market, we enable our clients to deliver secure, reliable, and innovative payment experiences to their customers.',
    icon: BanknotesIcon,
    href: '/#services',
    description: [
      'We support banks, payment processors, terminal vendors, and L3 application developers in achieving certification for their payment terminals in compliance with international and domestic payment scheme requirements.',
      'Our expertise helps organizations successfully deploy certified payment solutions, increase transaction acceptance volumes, adopt the latest payment technologies, and strengthen their position as market leaders within their respective regions.'
    ],
  },
  {
    id: 'issuing',
    number: '02',
    name: 'Issuing',
    shortDesc:
      'Card personalization, validation and issuing host certification for all major acceptance brands worldwide',
    icon: CreditCardIcon,
    href: '/#services',
    description: [
      'We support banks in modernizing their card portfolios by migrating to the latest payment technologies and scheme requirements.',
      'Our specialists help define and implement the most suitable card profiles, ensuring global acceptance across ATMs, POS terminals, contactless readers, and e-commerce channels. This allows banks to deliver enhanced customer experiences, maximize transaction acceptance, and stay ahead in the evolving payments ecosystem.',
    ],
  },
  {
    id: 'aws-consulting',
    number: '03',
    name: 'AWS / IT Consulting',
    shortDesc: 'Cloud migration, modernization, and IT consulting by certified AWS Solution Architects',
    icon: CubeIcon,
    href: '/#services',
    description: [
      'Our **AWS-certified Solution Architects** help you design, build, and optimize cloud solutions that are secure, scalable, and cost-efficient.',
      'Our expertise covers cloud migration, application modernization, and cloud-native solutions. We deliver future-ready IT infrastructure with reliability, security, and innovation at its core — tailored solutions that unlock the full potential of AWS and accelerate digital transformation.',
    ],
  },
]
